import React from 'react'
import NewLandingPageDesktop from './NewLandingPageDesktop';
import NewLandingPageMobile from './NewLandingPageMobile';
import { useEffect,useState } from 'react';

const NewLandingPageIndex = () => {
  const [screenSize, setScreenSize] = useState('');
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth >= 768) {
        setScreenSize('desktop');
      } else {
        setScreenSize('smartphone');
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <div>
      {screenSize === 'desktop' && <NewLandingPageDesktop />}
      {screenSize === 'smartphone' && <NewLandingPageMobile/>}
    </div>
  )
}

export default NewLandingPageIndex;
